import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

void (async function () {
  const carousels = document.querySelectorAll('.js-card-carousel')
  if (!carousels.length) {
    return
  }

  Swiper.use([Navigation, Pagination])

  for (const carousel of carousels) {
    const cards = carousel.querySelectorAll('.js-card')
    const display_bullets = carousel.dataset.displayBullets === 'true'
    const display_arrows = carousel.dataset.displayArrows === 'true'

    let wtDisable = false
    if (carousel.dataset.wtDisable === 'yes') {
      wtDisable = true
    }

    const trackingObjects = []
    if (!wtDisable) {
      try {
        for (const card of cards) {
          trackingObjects.push({
            nid: card.dataset.itemNid,
            nid_type: card.dataset.itemNidType
          })
        }
      } catch (e) {}
    }

    let wtData = {}
    if (!wtDisable) {
      try {
        wtData = JSON.parse(carousel.dataset.wtData)
      } catch (e) {}

      if (wtData['item']) {
        carousel.addEventListener('click', function (event) {
          const card = event.target.closest('.js-card')

          if (card) {
            _wt({
              category: 'item',
              action: 'click',
              values: [
                { type: card.dataset.itemNidType, value: card.dataset.itemNid }
              ],
              ...wtData['item']
            })
          }
        })
      }
    }

    let swiperSettings = {
      containerModifierClass: 'CardCarousel-wrapper-',
      spaceBetween: 20,
      slidesPerView: 'auto',
      simulateTouch: false,
      watchOverflow: true,
      preventInteractionOnTransition: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slideVisibleClass: 'is-visible'
    }

    if (display_bullets) {
      swiperSettings = {
        ...swiperSettings,
        pagination: {
          el: '.CardCarousel-bullets',
          bulletClass: 'CardCarousel-bullet',
          bulletActiveClass: 'is-active',
          type: 'bullets',
          dynamicBullets: true,
          renderBullet: (index, className) =>
            `<div class='[ f-bo-round ] CardCarousel-bullet ${className}'></div>`
        }
      }
    }

    if (display_arrows) {
      swiperSettings = {
        ...swiperSettings,
        navigation: {
          nextEl: '.CardCarousel-arrow-next',
          prevEl: '.CardCarousel-arrow-prev',
          disabledClass: 'is-disabled'
        }
      }
    }

    let SwiperObject = new Swiper(carousel, swiperSettings)

    if (!wtDisable) {
      const trackSlides = () => {
        let visibleIndices = []

        SwiperObject.slides.forEach((element, index) => {
          if (/is-visible/.test(element.className)) {
            visibleIndices.push(index)
          }
        })

        _wt({
          category: 'item-collection',
          action: 'display',
          values: trackingObjects
            .filter((element, index) => visibleIndices.indexOf(index) > -1)
            .map(item => ({ type: item.nid_type, value: item.nid })),
          ...(wtData['item-collection'] ? wtData['item-collection'] : {})
        })
      }

      /* Initial slides load */
      if (window.IntersectionObserver) {
        /* Modern browsers only track when carousel is in the viewport */
        const observer = new IntersectionObserver((entries, observer) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              trackSlides()
              observer.unobserve(entry.target)
            }
          }
        })

        observer.observe(carousel)
      } else {
        /* IE */
        trackSlides()
      }

      SwiperObject.on('slideChangeTransitionEnd', function () {
        trackSlides()
      })
    }
  }
})()
